import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isEmpty, get } from 'lodash';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';

import ChartCard from '../../ChartComponents/ChartCard';
import BarChart from '../../ChartComponents/BarChart';
import Info from '../../../../components/Info';
import { getPercentage } from '../../utils';

import style from '../HistogramChart/style.module.scss';

const CameraUsageChart = ({ cameraUsageData }) => {
  const [chartData, setChartData] = useState([]);
  const [dataType, setDataType] = useState('snapshots');

  useEffect(() => {
    if (!isEmpty(cameraUsageData)) {
      const dataArray = get(cameraUsageData, dataType, []);
      const totalAmount = dataArray.reduce((prev, curr) => (prev + curr.value), 0);
      const newChartData = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of dataArray) {
        newChartData.push({
          name: item.label,
          total: item.value,
          percentage: getPercentage(item.value, totalAmount),
        });
      }
      setChartData(newChartData);
    }
  }, [cameraUsageData, dataType]);

  const buttonsContainer = (
    <div className={style.ButtonsContainer}>
      <div className="text-center">
        <div className={style.eventControl}>
          <ToggleButtonGroup type="radio" name="eventStatus" value={dataType} onChange={setDataType}>
            <ToggleButton size="sm" value="snapshots">Snapshots</ToggleButton>
            <ToggleButton size="sm" value="users">Users</ToggleButton>
          </ToggleButtonGroup>
        </div>
      </div>
    </div>
  );

  if (!isEmpty(chartData)) {
    return (
      <ChartCard
        title={(
          <Info
            label="Top Camera Usage"
            content="The most used cameras aggregated by snapshots or users"
            className="ml-2"
          />
        )}
        header={buttonsContainer}
      >
        <BarChart
          data={chartData}
          dataKey="name"
          labelKey="percentage"
          xAxisKey="name"
          barKey="total"
          barColor="var(--theme-yellow-dark)"
          renderLabel
        />
      </ChartCard>
    );
  }

  return null;
};

export default connect(
  ({
    analytics: {
      basic: {
        data: {
          snapshotsByCamera,
          usersByCamera,
        },
      },
    },
  }) => ({
    cameraUsageData: {
      snapshots: snapshotsByCamera,
      users: usersByCamera,
    },
  }),
)(CameraUsageChart);
